import React from 'react';
import {
  Card,
  CardTitle,
  CardBody,
  Typography,
  Link,
} from '@one-thd/sui-atomic-components';
import { Refresh } from '@one-thd/sui-icons';
import proptypes from 'prop-types';
const { func } = proptypes;
import { PAYMENTS_PATH } from '../../constants/links';

export const ErrorCard = ({ onRefresh }) => {
  return (
    <Card grow PaperProps={{ className: 'sui-h-full' }} data-component="PaymentMethodCardErrorCard">
      <CardTitle
        header={(
          <Typography height="tight" variant="h3" weight="bold">
            Cards & Accounts
          </Typography>
        )}
      />
      <CardBody>
        <div className="sui-text-center sui-py-4">
          <Typography variant="body-lg">Something went wrong.</Typography>
          <Typography variant="body-lg">We couldn&apos;t load your information.</Typography>
          <div className="sui-my-8 sui-flex sui-justify-center">
            <Link onClick={onRefresh}>
              <div className="sui-grid sui-gap-y-3 sui-grid-cols-1 sui-justify-items-center">
                <Refresh size="large" />
                Refresh
              </div>
            </Link>
          </div>
          <Typography variant="body-lg">
            Or view your saved <Link href={PAYMENTS_PATH}>payment methods</Link>.
          </Typography>
        </div>
      </CardBody>
    </Card>
  );
};

ErrorCard.displayName = 'ErrorCard';

ErrorCard.propTypes = {
  onRefresh: func,
};

ErrorCard.defaultProps = {
  onRefresh: null
};